<ng-container *ngIf="!expanded; else noEllipsis">
  <span [title]="text">{{ text | truncate : limit }}</span>&nbsp;
  <a *ngIf="text.length > limit" (click)="expand(true)" (keyup.enter)="expand(true)" tabindex="0" role="button">Show more...</a>
</ng-container>

<ng-template #noEllipsis>
  <span>{{ text }}</span>&nbsp;
  <a (click)="expand(false)" (keyup.enter)="expand(false)" tabindex="0" role="button">Show less...</a>
</ng-template>
